import React from 'react';
import './AdminTableAnswersForType2.scss';
//import {printQuizesCategory} from "../../../../../utils/helps.js";
import TableAnswersForType2 from './TableAnswersForType2/TableAnswersForType2';
import { openAddInputFormsForAnswersType2  } from '../../../adminSlice';

export default class AdminTableAnswersForType2 extends React.Component {
    constructor(props) {
        super(props);
        
        this.onAdd = this.onAdd.bind(this);
    }

    onAdd() {
        const { dispatch } = this.props;
    
        dispatch(openAddInputFormsForAnswersType2());
    
    }
    render() {
        let style;
       // console.log(this.props.adminState.dataSubCategoryId.length);
        if (this.props.adminState.selectedQuestion) {
          
                style = ''
            } else {
                style = 'disabled'
            }

        const { dispatch} = this.props;
        return (
            
            <div className="AdminTableAnswersForType2">
                   <p className='tableName'>Список боксов {this.props.adminState.selectedQuestion} вопроса </p>

                   <TableAnswersForType2 
                   dispatch={dispatch}
                   data={this.props.adminState.dataAnswersIdForType2}
                   />

                   <button className='addButton' onClick={this.onAdd} disabled={style}>{/*<i className="fas fa-plus"></i>*/}</button> 

                    


                
            </div>
        )
    }
}